import { trackEvent } from '@fs/zion-analytics'
import React, { createContext, useContext, useState, useEffect } from 'react'

const DarkModeContext = createContext()
export const useDarkModeContext = () => useContext(DarkModeContext)

export default function DarkModeProvider({ children }) {
  const getUserPreference = () => JSON.parse(localStorage.getItem('fs.discovery.theme'))
  if (!getUserPreference()) localStorage.setItem('fs.discovery.theme', JSON.stringify('system')) // if localStorage not set yet, use system setting
  const isSystemDark = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  const checkIfDarkMode = () => (isSystemDark() && getUserPreference() === 'system') || getUserPreference() === 'dark'
  const [isDarkMode, setDarkMode] = useState(checkIfDarkMode())

  const handleSystemToggle = (e) => {
    const isSystemDarkNow = e?.matches
    trackEvent({ event_name: 'DarkModeProvider:SYSTEM_THEME:TOGGLE', isSystemDarkNow })
    if (isSystemDarkNow && getUserPreference() !== 'light' && !isDarkMode) setDarkMode(true)
    else if (!isSystemDarkNow && getUserPreference() !== 'dark' && isDarkMode) setDarkMode(false)
  }

  const handlePreferenceToggle = (pref) => {
    localStorage.setItem('fs.discovery.theme', JSON.stringify(pref))
    trackEvent({ event_name: 'ThemeMenuItem:TOGGLE_THEME:CLICK', value: pref })
    if (pref === 'system') {
      if (isSystemDark() && !isDarkMode) setDarkMode(true)
      if (!isSystemDark() && isDarkMode) setDarkMode(false)
    } else {
      if (pref === 'dark' && !isDarkMode) setDarkMode(true)
      if (pref === 'light' && isDarkMode) setDarkMode(false)
    }
  }

  useEffect(() => {
    let mounted = true
    const watcher = window.matchMedia('(prefers-color-scheme: dark)')

    // listen for changes to system theme setting
    if (mounted && watcher) {
      if (watcher.addEventListener) watcher.addEventListener('change', handleSystemToggle)
      else if (watcher.addListener) watcher.addListener(handleSystemToggle) // iOS compatibility
    }

    return () => {
      if (watcher.removeEventListener) watcher.removeEventListener('change', handleSystemToggle)
      else if (watcher.removeListener) watcher.removeListener(handleSystemToggle)
      mounted = false
    }
  })

  return (
    <DarkModeContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        isDarkMode,
        handlePreferenceToggle,
      }}
    >
      {children}
    </DarkModeContext.Provider>
  )
}
